let API_PATH;

switch (process.env.NODE_ENV) {

  case 'production':
    API_PATH = '';
    break;

  case 'test':
    API_PATH = '/app_test.php';
    break;

  case 'development':
    // path = '/app_dev.php';
    API_PATH = '';
    break;

  default:
    throw new Error('Unknown environment (' + process.env.NODE_ENV + ')');
}

// Default to using the NGINX container endpoint...
let API_HOST;

// To use the varnish container endpoint, uncomment this line...
//export const API_HOST = 'http://api-platform.localhost';

/**
 * Now we define endpoints as per the deployment environment…
 */
switch (process.env.REACT_APP_DEPLOY_ENV) {

  case "prod":
    // Note this is the temporary prod URL
    API_HOST = 'https://api.directoryservice.prod.cubicmushroom.com';
    break;

  default:
    API_HOST = 'http://api-platform.localhost:8080';

}

export {
  API_HOST,
  API_PATH
};


// WEBPACK FOOTER //
// ./src/config/_entrypoint.js